// extracted by mini-css-extract-plugin
module.exports = {"signin":"SignIn_signin__2nnky","links":"SignIn_links__SsMsQ","link":"SignIn_link__2TgVY"};